module.exports = __webpack_public_path__ + "img/big_1_64.f8f5607a.png";